export default "__VITE_ASSET__DLFx8aMq__"